// extracted by mini-css-extract-plugin
export default {"container":"PasswordValidationRules_container__Zh1v9","ruleBox":"PasswordValidationRules_ruleBox__pWXWg","ruleText":"PasswordValidationRules_ruleText__6gOUD"};